import React, { useEffect, useState, useRef, useCallback } from 'react';
import './Inicio.css';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import { useCart } from '../../context/CartContext';
import WhatsAppWidget from '../../components/WhatsAppWidget';

const API_CURSOS = 'https://centrocomunicar.com/api-comunicar/endpoints/courses.php?action=list';
const API_HERO = 'https://centrocomunicar.com/api-comunicar/endpoints/hero_carrusel.php';

/* ════════ LOGO ════════ */
const LogoComunicar = ({ height = 40 }) => (
  <svg height={height} viewBox="0 0 280 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Burbuja grande teal */}
    <ellipse cx="26" cy="22" rx="22" ry="19" fill="#14736C"/>
    <path d="M12 38 Q8 46 5 50 Q14 44 19 40Z" fill="#14736C"/>
    {/* Burbuja pequeña amarilla */}
    <ellipse cx="42" cy="30" rx="13" ry="11" fill="#FFEEB6"/>
    <path d="M34 39 Q31 44 29 47 Q36 43 39 40Z" fill="#FFEEB6"/>
    {/* Puntos blancos en burbuja grande */}
    <circle cx="19" cy="22" r="2.2" fill="white"/>
    <circle cx="26" cy="22" r="2.2" fill="white"/>
    <circle cx="33" cy="22" r="2.2" fill="white"/>
    {/* Texto "comunicar" en Alphazet */}
    <text x="62" y="30" fontFamily="'Alphazet', 'DM Sans', sans-serif" fontWeight="400" fontSize="22" fill="#14736C">comunicar</text>
    <text x="64" y="44" fontFamily="'DM Sans', sans-serif" fontWeight="400" fontSize="9" fill="#8BCAAF">Lenguaje, aprendizaje y habla</text>
  </svg>
);

/* ════════ ICONS ════════ */
const IconArrow     = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevLeft  = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevRight = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconStar      = () => (<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconCheck     = () => (<svg viewBox="0 0 20 20" fill="none" width="18" height="18" style={{flexShrink:0}}><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.25)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCart      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBag       = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

/* ════════ SLIDES ════════ */


const DIFERENCIAL = [
  { texto: 'Cursos que te enseñan exactamente qué hacer en terapia' },
  { texto: 'Materiales descargables para usar con tus pacientes' },
  { texto: 'Todo pensado para que lo apliques desde la primera sesión' },
];

const TESTIMONIOS = [
  { nombre: 'Rosario López', ocupacion: 'Terapeuta del habla y lenguaje, Santo Domingo, República Dominicana', texto: 'Para mí las formaciones de comunicar han sido de mucha ayuda para seguir capacitándome,son prácticos y de fácil acceso. Muy útiles para estar actualizados ❤️', estrellas: 5 },
  { nombre: 'Gloria Zapata', ocupacion: 'Psicóloga especialista en trastornos de la comunicación y lenguaje, Trujillo, Perú', texto: 'Comunicar no solo aporta conocimientos, sino que también brinda herramientas útiles y actualizadas para el ejercicio profesional. Estoy muy agradecida por todo lo aprendido.', estrellas: 5 },
  { nombre: 'Liana Martínez', ocupacion: 'Especialista en aprendizaje, comunicación y lenguaje, Lima, Perú', texto: 'Los cursos que recibí han significado un aporte muy importante en mi desarrollo profesional. Valoro mucho el enfoque práctico de los cursos, esto hace que tenga un impacto real en la práctica diaria.', estrellas: 5 },
];


const SLIDES_FALLBACK = [
  {
    id: 'cursos', modo:'contenido',
    tag: 'Formación especializada',
    titulo: 'Aprende exactamente\nqué hacer en terapia',
    subtitulo: 'No solo teoría.',
    descripcion: 'Cursos grabados y en vivo diseñados por especialistas en lenguaje, comunicación y habla. Certificación incluida.',
    items: ['Cursos grabados a tu ritmo','Formaciones en vivo con expertos','Certificado oficial al completar'],
    btn1_texto:'Ver Cursos', btn1_link:'/formaciones',
    btn2_texto:'Explorar gratis', btn2_link:'/formaciones#gratuitos',
    bg_clase:'slide--cursos',
    card:{ titulo:'Evaluación del Lenguaje en niños', precio:'S/. 120', stat:'320 estudiantes inscritos', badge1:'★ 4.9 valoración', badge2:'🎓 Certificado incluido' },
  },
  {
    id: 'materiales', modo:'contenido',
    tag: 'Materiales terapéuticos',
    titulo: 'Recursos listos para\nusar desde hoy',
    subtitulo: 'Aplicable desde la primera sesión.',
    descripcion: 'Imprimibles, cuadernillos y juegos terapéuticos organizados por área y nivel de desarrollo.',
    items: ['Imprimibles listos para usar','Cuadernillos de trabajo','Juegos terapéuticos validados'],
    btn1_texto:'Ver Materiales', btn1_link:'/recursos',
    btn2_texto:'Ver materiales gratis', btn2_link:'/recursos#gratuitos',
    bg_clase:'slide--materiales',
    card:{ titulo:'Kit Imprimible Fonología', precio:'S/. 25', stat:'180 descargas este mes', badge1:'✓ Listo para imprimir', badge2:'📥 Descarga inmediata' },
  },
];

/* ════════ TOAST CARRITO ════════ */
function ToastCarrito({ item, onVer, onCerrar }) {
  useEffect(() => {
    const t = setTimeout(onCerrar, 3500);
    return () => clearTimeout(t);
  }, [onCerrar]);
  return (
    <div style={{
      position:'fixed', bottom:'2rem', right:'2rem', zIndex:9999,
      background:'#111614', color:'#fff', borderRadius:16,
      padding:'1rem 1.2rem', boxShadow:'0 8px 32px rgba(0,0,0,.35)',
      display:'flex', alignItems:'center', gap:'1rem',
      maxWidth:320, width:'90%',
    }}>
      <div style={{width:38,height:38,borderRadius:10,background:'#82D8B3',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
        <IconCheck/>
      </div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'.72rem',color:'rgba(255,255,255,.5)',marginBottom:'.1rem'}}>Agregado al carrito</div>
        <div style={{fontSize:'.86rem',fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item?.titulo}</div>
      </div>
      <button onClick={onVer} style={{background:'#82D8B3',color:'#111614',border:'none',borderRadius:100,padding:'.4rem .85rem',fontFamily:'inherit',fontWeight:700,fontSize:'.75rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>
        Ver carrito
      </button>
    </div>
  );
}

/* ════════ CARD CURSO CON CARRITO ════════ */
function CursoCard({ curso }) {
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();
  const navigate = useNavigate();
  const enCarrito = estaEnCarrito('curso-' + curso.id);
  const precio = parseFloat(curso.precio_web || 0);
  const tieneColor = ['lenguaje','tea','habla','aprendizaje'];
  const cat = (curso.categoria || '').toLowerCase();
  const colorClass = tieneColor.includes(cat) ? cat : 'lenguaje';

  return (
    <div className="dest-card reveal" style={{display:'flex',flexDirection:'column'}}>
      <div className={`dest-card__thumb dest-card__thumb--${colorClass}`}>
        {curso.etiqueta && <span className="dest-card__tipo">{curso.etiqueta}</span>}
       
        {curso.imagen_url && (
          <img
            src={curso.imagen_url}
            alt={curso.fullname}
            style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',borderRadius:'inherit'}}
          />
        )}

      </div>
      <div className="dest-card__body" style={{flex:1}}>
        <span className="dest-card__cat">{curso.categoria || 'Formación'}</span>
        <h3 style={{fontSize:'.92rem',lineHeight:1.4}}>{curso.fullname}</h3>
        {curso.fecha_inicio && (
          <p style={{fontSize:'.75rem',color:'#5a6a63',marginTop:'.3rem'}}>📅 {curso.fecha_inicio}</p>
        )}
      </div>
      <div className="dest-card__footer" style={{flexDirection:'column',gap:'.6rem',alignItems:'stretch'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <strong className="dest-card__precio">
              {precio > 0 ? `S/. ${precio.toFixed(0)}` : 'Gratis'}
            </strong>
            {curso.precio_anterior && (
              <s style={{fontSize:'.78rem',color:'#9ca3af',marginLeft:'.4rem'}}>
                S/. {parseFloat(curso.precio_anterior).toFixed(0)}
              </s>
            )}
          </div>
          <Link to={'/formaciones/' + curso.id} className="dest-card__btn" style={{fontSize:'.75rem'}}>
            Ver curso →
          </Link>
        </div>
        {/* Botón carrito — solo si tiene precio */}
        {precio > 0 && (
          <div style={{display:'flex',gap:'.4rem'}}>
            {enCarrito ? (
              <button
                onClick={() => navigate('/carrito')}
                style={{
                  flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:'.35rem',
                  background:'#4db88a', color:'#fff', border:'none', borderRadius:100,
                  padding:'.52rem .9rem', fontFamily:'inherit', fontWeight:700, fontSize:'.78rem', cursor:'pointer',
                }}
              >
                <IconBag/> Ver carrito
              </button>
            ) : (
              <button
              onClick={() => {
                if (!estaLogueado) { navigate('/login?redirect=/formaciones'); return; }
                agregarItem({
                  id:      'curso-' + curso.id,
                  titulo:  curso.fullname,
                  precio:  precio,
                  tipo:    'curso',
                  color:   'verde',
                  imagen:  curso.imagen_url || null,
                  digital: true,
                });
              }}
                style={{
                  flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:'.35rem',
                  background:'#111614', color:'#82D8B3', border:'none', borderRadius:100,
                  padding:'.52rem .9rem', fontFamily:'inherit', fontWeight:700, fontSize:'.78rem', cursor:'pointer',
                  transition:'all .2s',
                }}
              >
                <IconCartPlus/> Agregar al carrito
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function Inicio() {
  const { estaLogueado, usuario } = useAuthUser();
  const { totalItems, ultimoAgregado, limpiarUltimoAgregado } = useCart();
  const [slides,       setSlides]       = useState(SLIDES_FALLBACK);
  const [loadingHero,  setLoadingHero]  = useState(true);
 
  useEffect(() => {
    fetch(API_HERO + '?action=list')
      .then(r => r.json())
      .then(j => {
        if (j.success && j.data && j.data.length > 0) {
          setSlides(j.data);
        }
        // Si falla o no hay slides, usa el fallback que ya está en el estado
      })
      .catch(() => {})
      .finally(() => setLoadingHero(false));
  }, []);

  const navigate = useNavigate();

  const [slideActivo, setSlideActivo] = useState(0);
  const [animando,    setAnimando]    = useState(false);
  const intervalRef = useRef(null);

  /* Cursos destacados desde API */
  const [cursosDestacados,    setCursosDestacados]    = useState([]);
  const [loadingCursos,       setLoadingCursos]       = useState(true);
  const [materialesDestacados,setMaterialesDestacados]= useState([]);
  const [loadingMateriales,   setLoadingMateriales]   = useState(true);

  useEffect(() => {
    fetch(API_CURSOS)
      .then(r => r.json())
      .then(j => {
        if (j.success && j.data) {
          const dest = j.data
            .filter(c => c.destacado && c.precio_web > 0)
            .slice(0, 3);
          // Si no hay destacados con precio, tomar los 3 primeros con precio
          if (dest.length === 0) {
            const conPrecio = j.data.filter(c => c.precio_web > 0).slice(0, 3);
            setCursosDestacados(conPrecio);
          } else {
            setCursosDestacados(dest);
          }
        }
      })
      .catch(() => {})
      .finally(() => setLoadingCursos(false));
  }, []);

 
  


  useEffect(() => {
    fetch('https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php?action=list')
      .then(r => r.json())
      .then(j => {
        if (j.success && j.data?.length > 0) {
          // Primero destacados, luego el resto, tomar 3
          const destacados = j.data.filter(r => r.destacado);
          const noDestacados = j.data.filter(r => !r.destacado);
          const seleccion = [...destacados, ...noDestacados].slice(0, 3);
          setMaterialesDestacados(seleccion);
        }
      })
      .catch(() => {})
      .finally(() => setLoadingMateriales(false));
  }, []);


  const irASlide = useCallback((idx) => {
    if (animando) return;
    setAnimando(true);
    setTimeout(() => { setSlideActivo(idx); setAnimando(false); }, 350);
  }, [animando]);

  const siguiente = useCallback(() => {
    irASlide((slideActivo + 1) % totalSlides);
  }, [slideActivo, irASlide]);

  const anterior = useCallback(() => {
    irASlide((slideActivo - 1 + totalSlides) % totalSlides);
  }, [slideActivo, irASlide]);

  useEffect(() => {
    intervalRef.current = setInterval(siguiente, 6000);
    return () => clearInterval(intervalRef.current);
  }, [siguiente]);

  const pausar   = () => clearInterval(intervalRef.current);
  const reanudar = () => { intervalRef.current = setInterval(siguiente, 6000); };

  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
    return () => io.disconnect();
  }, [loadingCursos]);

   const slide = slides[slideActivo] || SLIDES_FALLBACK[0];
  const totalSlides = slides.length;

  return (
    <div className="inicio">

      {/* Toast carrito */}
      {ultimoAgregado && (
        <ToastCarrito
          item={ultimoAgregado}
          onVer={() => { navigate('/carrito'); limpiarUltimoAgregado(); }}
          onCerrar={limpiarUltimoAgregado}
        />
      )}

      {/* ══ NAV ══ */}
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones">Cursos</Link>
          <Link to="/recursos">Materiales</Link>
          <Link to="/comunidad">Comunidad</Link>
          <Link to="/articulos">Artículos</Link>

          {/* Icono carrito en nav */}
          <Link
            to="/carrito"
            style={{position:'relative',display:'flex',alignItems:'center',padding:'.4rem .7rem',borderRadius:100,border:'1.5px solid rgba(130,216,179,.3)',color:'var(--gris,#5a6a63)',transition:'all .2s'}}
            title="Ver carrito"
          >
            <IconCart/>
            {totalItems > 0 && (
              <span style={{position:'absolute',top:-6,right:-6,background:'#82D8B3',color:'#111614',borderRadius:'50%',width:18,height:18,fontSize:'.62rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                {totalItems > 9 ? '9+' : totalItems}
              </span>
            )}
          </Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      {/* ══ HERO CARRUSEL — CONSERVADO INTACTO ══ */}
      <section
        className={`hero-carousel ${slide.bg_clase || slide.bg || ''} ${animando ? 'hero-carousel--saliendo' : 'hero-carousel--entrando'}`}
        style={slide.imagen_url ? {backgroundImage:`url(${slide.imagen_url})`, backgroundSize:'cover', backgroundPosition: slide.imagen_position || 'center'} : {}}
        onMouseEnter={pausar}
        onMouseLeave={reanudar}
      >
        <div className="hero-carousel__bg">
          <div className="hc__blob hc__blob--a"/>
          <div className="hc__blob hc__blob--b"/>
        </div>
        <div className="hero-carousel__inner">
          <div className="hero-carousel__content">
            
            
          {slide.modo === 'imagen' ? (
              /* Slide imagen full — sin contenido superpuesto */
              slide.imagen_link
                ? <Link to={slide.imagen_link} style={{display:'block',width:'100%',height:'100%'}}/>
                : null
            ) : (
              <>
                {slide.tag && <span className="hc__tag">{slide.tag}</span>}
                {slide.subtitulo && <p className="hc__super">{slide.subtitulo}</p>}
                <h1 className="hc__titulo">
                  {(slide.titulo||'').split('\n').map((line, i) => (
                    <span key={i}>{line}{i === 0 && <br/>}</span>
                  ))}
                </h1>
                {slide.descripcion && <p className="hc__desc">{slide.descripcion}</p>}
                {slide.items && slide.items.length > 0 && (
                  <ul className="hc__lista">
                    {slide.items.filter(Boolean).map(it => (<li key={it}><IconCheck/>{it}</li>))}
                  </ul>
                )}
                <div className="hc__btns">
                  {slide.btn1_texto && <Link to={slide.btn1_link||'/'} className="hc__btn hc__btn--primary">{slide.btn1_texto} <IconArrow/></Link>}
                  {slide.btn2_texto && <Link to={slide.btn2_link||'/'} className="hc__btn hc__btn--ghost">{slide.btn2_texto}</Link>}
                </div>
              </>
            )}



          </div>
          <div className="hero-carousel__visual">
            <div className="hc__card-stack">
             
             
            {slide.modo !== 'imagen' && slide.card && (
                <>
                  <div className="hc__card hc__card--main">
                    <div className="hc__card-tag">
                      {slide.card.titulo ? '🎓 Destacado' : '📦 Material destacado'}
                    </div>
                    <h3>{slide.card.titulo || ''}</h3>
                    {slide.card.stat && <p>{slide.card.stat}</p>}
                    {slide.card.precio && <div className="hc__card-price">{slide.card.precio}</div>}
                    <Link to={slide.btn1_link||'/'} className="hc__card-btn">Ver ahora →</Link>
                  </div>
                  {slide.card.badge1 && (
                    <div className="hc__card hc__card--badge hc__card--badge-a">{slide.card.badge1}</div>
                  )}
                  {slide.card.badge2 && (
                    <div className="hc__card hc__card--badge hc__card--badge-b">{slide.card.badge2}</div>
                  )}
                </>
              )}
 


            </div>
          </div>
        </div>
        <button className="hc__arrow hc__arrow--left"  onClick={anterior} aria-label="Anterior"><IconChevLeft/></button>
        <button className="hc__arrow hc__arrow--right" onClick={siguiente} aria-label="Siguiente"><IconChevRight/></button>
        <div className="hc__dots">
        {slides.map((_, i) => (
            <button key={i} className={`hc__dot ${i === slideActivo ? 'hc__dot--active' : ''}`} onClick={() => irASlide(i)} aria-label={`Slide ${i + 1}`}/>
          ))}
        </div>
        <div className="hc__progress"><div className="hc__progress-bar" key={slideActivo}/></div>
      </section>

      {/* ══ CURSOS DESTACADOS — CON CARRITO ══ */}
      <section className="dest-section reveal" id="cursos-destacados">
        <div className="dest-section__inner">
          <div className="dest-section__head">
            <div>
              <p className="section-label">Oferta académica</p>
              <h2>Cursos <em>destacados</em></h2>
            </div>
            <Link to="/formaciones" className="dest-section__cta">Explorar cursos<IconArrow/></Link>
          </div>

          {loadingCursos ? (
            <div style={{textAlign:'center',padding:'3rem',color:'#5a6a63',fontSize:'.9rem'}}>
              Cargando cursos…
            </div>
          ) : cursosDestacados.length === 0 ? (
            /* Fallback: cards estáticas si no hay datos */
            <div className="dest-grid">
              {[
                { titulo:'Evaluación del Lenguaje en niños', precio:'S/. 120', tipo:'Grabado', cat:'Lenguaje' },
                { titulo:'Comunicación en TEA', precio:'S/. 150', tipo:'En vivo', cat:'TEA' },
                { titulo:'Terapia de Tartamudez avanzada', precio:'S/. 90', tipo:'Grabado', cat:'Habla' },
              ].map((c, i) => (
                <Link to="/formaciones" className="dest-card reveal" key={c.titulo} style={{'--delay':`${i*0.1}s`}}>
                  <div className={`dest-card__thumb dest-card__thumb--${c.cat.toLowerCase()}`}>
                    <span className="dest-card__tipo">{c.tipo}</span>
                  </div>
                  <div className="dest-card__body">
                    <span className="dest-card__cat">{c.cat}</span>
                    <h3>{c.titulo}</h3>
                  </div>
                  <div className="dest-card__footer">
                    <strong className="dest-card__precio">{c.precio}</strong>
                    <span className="dest-card__btn">Ver curso →</span>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="dest-grid">
              {cursosDestacados.map((c, i) => (
                <div key={c.id} style={{'--delay':`${i*0.1}s`}}>
                  <CursoCard curso={c}/>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ══ MATERIALES DESTACADOS — CONSERVADO INTACTO ══ */}
    {/* ══ MATERIALES DESTACADOS — dinámico desde API ══ */}
    <section className="dest-section dest-section--mat reveal">
        <div className="dest-section__inner">
          <div className="dest-section__head">
            <div>
              <p className="section-label">Recursos terapéuticos</p>
              <h2>Materiales <em>destacados</em></h2>
            </div>
            <Link to="/recursos" className="dest-section__cta">Explorar materiales <IconArrow/></Link>
          </div>

          {loadingMateriales ? (
            <div style={{textAlign:'center',padding:'3rem',color:'#5a6a63',fontSize:'.9rem'}}>
              Cargando materiales…
            </div>
          ) : (
            <div className="dest-grid">
              {materialesDestacados.map((m, i) => {
                const TIPO_LABEL = { recurso:'Imprimible', kit:'Cuadernillo', juego:'Juego' };
                const colorMap   = { verde:'lenguaje', azul:'tea', amarillo:'habla', morado:'aprendizaje', rosa:'habla', gris:'lenguaje' };
                const catClass   = colorMap[m.color] || 'lenguaje';
                return (
                  <Link to={`/recursos/${m.id}`} className="dest-card dest-card--mat reveal" key={m.id} style={{'--delay':`${i*0.1}s`}}>
                <div
  className={`dest-card__thumb dest-card__thumb--mat dest-card__thumb--${catClass} dest-card__thumb--mat-img`}
  style={m.imagen_url ? {backgroundImage:`url(${m.imagen_url})`,backgroundSize:'cover',backgroundPosition:'center'} : {}}
>
                      {!m.imagen_url && <span className="dest-card__tipo">{TIPO_LABEL[m.tipo]||m.tipo}</span>}
                      {m.imagen_url  && <span className="dest-card__tipo" style={{background:'rgba(0,0,0,.45)',color:'#fff'}}>{TIPO_LABEL[m.tipo]||m.tipo}</span>}
                    </div>
                    <div className="dest-card__body">
                      <span className="dest-card__cat">{m.categoria}</span>
                      <h3>{m.titulo}</h3>
                      {m.descripcion && <p style={{fontSize:'.78rem',color:'#5a6a63',marginTop:'.3rem',lineHeight:1.5}}>{m.descripcion.slice(0,80)}{m.descripcion.length>80?'…':''}</p>}
                    </div>
                    <div className="dest-card__footer">
                      <strong className="dest-card__precio">S/. {parseFloat(m.precio||0).toFixed(0)}</strong>
                      <span className="dest-card__btn">Ver detalle →</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* ══ DIFERENCIAL — CONSERVADO INTACTO ══ */}
      <section className="diferencial reveal">
        <div className="diferencial__inner">
          <div className="diferencial__texto">
            <p className="section-label" style={{color:'var(--verde)'}}>Por qué Comunicar</p>
            <h2>"No solo teoría.<br/><em>Aquí aprendes exactamente<br/>qué hacer en terapia."</em></h2>
            <ul className="diferencial__lista">
              {DIFERENCIAL.map(d => (<li key={d.texto}><IconCheck/><span>{d.texto}</span></li>))}
            </ul>
            <Link to="/formaciones" className="diferencial__btn">Explorar cursos <IconArrow/></Link>
          </div>
          <div className="diferencial__visual">
            <div className="dif__stat-grid">
              <div className="dif__stat"><strong>+500</strong><span>Profesionales formados</span></div>
              <div className="dif__stat"><strong>100%</strong><span>Aplicable en sesión</span></div>
              <div className="dif__stat"><strong>+5</strong><span>Países alcanzados</span></div>
              <div className="dif__stat"><strong>+30</strong><span>Formaciones dictadas</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ QUIÉNES SOMOS — CONSERVADO INTACTO ══ */}
      <section className="quienes reveal">
        <div className="quienes__inner">
          <div className="quienes__col">
            <p className="section-label">Quiénes somos</p>
            <h2>Como nace<br/><em>Comunicar</em></h2>
            <p className="quienes__texto">Comunicar nace desde la práctica clínica,
de lo que realmente pasa en sesión y de la necesidad de hacerlo más claro y aplicable.
</p>
            <p className="quienes__texto">Hoy transformamos esa experiencia en formación y materiales diseñados para terapeutas que buscan herramientas concretas y basadas en evidencia.</p>
            <Link to="/comunidad" className="quienes__btn">Conocer la comunidad <IconArrow/></Link>
          </div>
          <div className="quienes__col quienes__col--diana">
            <div className="diana__card">
              <div className="diana__avatar">D</div>
              <div className="diana__info">
                <p className="section-label">Sobre Diana</p>
                <h3>Soy Diana Ayay<br/></h3>
                <p>Trabajo en terapia de lenguaje desde hace más de 10 años. A partir de esta experiencia, empecé a diseñar materiales y formaciones que respondan a una necesidad concreta:saber qué hacer en terapia.</p>
                <p>Hoy comparto herramientas diseñadas para hacer la intervención más clara, estructurada y aplicable, siempre pensando en lo que realmente funciona en sesión.</p>
                <div className="diana__tags">
                  <span>Terapia de Lenguaje</span><span>Tartamudez</span><span>TDL</span><span>Evaluación</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ TESTIMONIOS — CONSERVADO INTACTO ══ */}
      <section className="testimonios reveal">
        <div className="testimonios__inner">
          <div className="testimonios__head">
            <p className="section-label">Comunidad real</p>
            <h2>Lo que dicen<br/><em>nuestros clientes</em></h2>
          </div>
          <div className="test-grid">
            {TESTIMONIOS.map((t, i) => (
              <div className="test-card reveal" key={t.nombre} style={{'--delay':`${i*0.12}s`}}>
                <div className="test-stars">{[...Array(t.estrellas)].map((_, j) => <IconStar key={j}/>)}</div>
                <p className="test-texto">"{t.texto}"</p>
                <div className="test-autor">
                  <div className="test-avatar">{t.nombre.charAt(0)}</div>
                  <div><strong>{t.nombre}</strong><span>{t.ocupacion}</span></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ FOOTER — CONSERVADO INTACTO ══ */}
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="footer__brand-desc">Cursos especializados y materiales terapéuticos para profesionales y familias que trabajan el desarrollo del lenguaje.</p>
            <div className="footer__social">
            <a href="https://www.instagram.com/comunicar_terapias?fbclid=IwY2xjawRS90JleHRuA2FlbQIxMABicmlkETFsTWNRclhmY2hiTzRvTndDc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHq32WKTsoRBD35O1FJxG61CJ733vEK4GryiNvmMbbLmdCCEyxitSoS8ns6QR_aem_7hu4_QjxX4oXanDtpj-WpQ" className="footer__social-btn" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg></a>
              <a href="https://www.facebook.com/comunicar.terapias" className="footer__social-btn" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
              <a href="https://api.whatsapp.com/send/?phone=51940686868&text&type=phone_number&app_absent=0" className="footer__social-btn" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
            </div>
          </div>
          <div className="footer__cols">
            <div className="footer__col">
              <h4>Cursos</h4>
              <Link to="/formaciones">Cursos grabados</Link>
              <Link to="/formaciones">Cursos en vivo</Link>
              <Link to="/formaciones#calendario">Calendario académico</Link>
              <a href="https://centrocomunicar.com/virtual/login/index.php" target="_blank" rel="noopener noreferrer">Aula virtual ↗</a>
            </div>
            <div className="footer__col">
              <h4>Materiales</h4>
              <Link to="/recursos">Imprimibles</Link>
              <Link to="/recursos">Cuadernillos</Link>
              <Link to="/recursos">Juegos terapéuticos</Link>
            </div>
            <div className="footer__col">
              <h4>Comunidad</h4>
              <Link to="/comunidad">Redes sociales</Link>
              <Link to="/comunidad">Boletín mensual</Link>
              <Link to="/comunidad">Programa de puntos</Link>
            </div>
          </div>
          <div className="footer__newsletter">
            <h4>Recibe novedades</h4>
            <p>Materiales gratuitos y nuevos cursos directamente en tu correo.</p>
            <div className="footer__form">
              <input type="email" placeholder="tu@correo.com" className="footer__input"/>
              <button className="footer__submit" aria-label="Suscribirse"><IconArrow/></button>
            </div>
            <div className="footer__legal-links">
              <Link to="/atencion-cliente">Atención al cliente</Link>
              <Link to="/legal">Legal</Link>
              <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
          <p style={{fontSize:'.75rem',color:'rgba(255,255,255,.3)',marginTop:'.3rem'}}>
            Dirección: Teniente Carlos Moore 1386, Cercado de Lima
          </p>
          <div className="footer__legal">
            <Link to="/legal">Privacidad</Link>
            <Link to="/legal">Términos y condiciones</Link>
            <Link to="/politica-devoluciones">Política de devoluciones</Link>
          </div>
        </div>
      </footer>

      <WhatsAppWidget/>






   {/* Widget redes sociales flotante */}
   <div style={{position:'fixed',right:0,top:'50%',transform:'translateY(-50%)',zIndex:100,display:'flex',flexDirection:'column',gap:2}}>
  {[
    { href:'https://www.facebook.com/comunicar.terapias', bg:'#1877f2', icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg> },
    { href:'https://www.instagram.com/comunicar_terapias', bg:'#e1306c', icon:<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg> },
    { href:'https://api.whatsapp.com/send/?phone=51940686868', bg:'#25d366', icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> },
    { href:'https://www.youtube.com/@comunicar', bg:'#ff0000', icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg> },
  ].map(({href,bg,icon}) => (
    <a key={href} href={href} target="_blank" rel="noopener noreferrer"
      style={{width:40,height:40,background:bg,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',transition:'width .2s'}}>
      {icon}
    </a>
  ))}
</div>





    </div>
  );
}